import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { SegmentedControl } from '@kerfjs/ui/segmented-control';
import { type SafeHtml } from 'kerfjs';

import { summaryPane } from '../../data/state.js';
import { DecisionSummaryPane } from './components/decision-summary-pane.js';
import { OutcomesPane } from './components/outcomes-pane.js';
import { OverviewPane } from './components/overview-pane/index.js';

/** Summary / Outcomes: a full-width segmented control (HS2-D2W8M2) switches between
 *  the pricing-check Overview, the business-office Decision Summary, and the
 *  purchase Outcomes. The section title lives in the editor sub-header, so no
 *  in-content heading is drawn here (HS2-QYKWSQ). */
export function DemandSummarySegment(): SafeHtml {
  const pane = summaryPane.value;
  return (
    <List className="demand-summary-segment" gap="m" controlInsets="tb">
      <Row controlInsets="rl">
        <SegmentedControl
          id="summary-pane"
          label="Summary View"
          value={pane}
          action="summary-pane"
          appearance="filled"
          shape="rounded"
          size="default"
          layout="equal"
          choices={[
            { value: 'overview', label: 'Overview' },
            { value: 'decision', label: 'Decision Summary' },
            { value: 'outcomes', label: 'Outcomes' },
          ]}
        />
      </Row>
      {(() => {
        switch (pane) {
          case 'decision':
            return <DecisionSummaryPane />;
          case 'outcomes':
            return <OutcomesPane />;
          case 'overview':
            return <OverviewPane />;
        }
      })()}
    </List>
  );
}
